/** 🔥 all type are based on this Enum */
export const MasterPanelStates = {
  Open: 'Open',
  Close: 'Close',
} as const;
Object.freeze(MasterPanelStates);

export type MasterPanelState = (typeof MasterPanelStates)[keyof typeof MasterPanelStates];
